import spainTranslations from "./spainTranslations";
import portugalTranslations from "./portugalTranslations";
import mexicoTranslations from "./mexicoTranslations";

const availableCountries = ["ES", "PT", "MX"];

const translationsConfig = {
  ES: spainTranslations,
  PT: portugalTranslations,
  MX: mexicoTranslations,
};

const alternateCountryTranslations = (country, key) => {
  if (availableCountries.indexOf(country) === -1) {
    return key;
  }
  return translationsConfig[country][key] || key;
};

export default alternateCountryTranslations;
